export const CURRENT_YEAR = new Date().getFullYear();
export const CURRENT_YEAR_SHORT = String(CURRENT_YEAR).slice(-2);
